export class VerificationLookupRequest{
    centerId:string;
    searchCriteria:string;

    constructor(center:string, criteria:string){
        this.centerId = center;
        this.searchCriteria = criteria;
    }
}